const newsletterCta = {
  init() {
    const ctaForms = Array.from(
      document.querySelectorAll('.newsl-cta:not(.newsl-cta--modal)')
    );

    this.setStaticHeight(ctaForms);

    window.addEventListener('resize', () => this.setStaticHeight(ctaForms));
  },

  addStaticHeight(el) {
    if (el && el.clientHeight) {
      el.style.height = '';
      el.style.height = `${el.clientHeight}px`;
    }
  },

  setStaticHeight(els) {
    els.forEach((el) => {
      this.addStaticHeight(el);
    });
  },
};

export default newsletterCta;
